import { getIn, setIn } from 'formik';

import { ConnectionField } from '../InstallView/parseConnectionFields';

/**
 * Reads the current form value for each of the chart's fields as a string. The
 * installed release's values parse to real types (numbers, booleans) while the
 * field inputs emit strings, so both sides are stringified here to compare
 * apples-to-apples for dirty detection.
 */
export function toFieldStrings(
  fields: Array<ConnectionField>,
  values: Record<string, unknown>
): Record<string, string> {
  return fields.reduce<Record<string, string>>((acc, field) => {
    acc[field.key] = stringifyValue(getIn(values, field.key));
    return acc;
  }, {});
}

/**
 * Builds the upgrade payload from only the fields whose value differs from the
 * new version's chart default, rebuilt into the nested shape Helm expects.
 * Sending this delta (rather than the release's full computed values) keeps a
 * version bump from pinning the old chart's defaults onto the new chart.
 */
export function buildOverrides(
  fields: Array<ConnectionField>,
  values: Record<string, unknown>
): Record<string, unknown> {
  return fields.reduce<Record<string, unknown>>((acc, field) => {
    const current = stringifyValue(getIn(values, field.key));
    if (current === field.value) {
      return acc;
    }
    return setIn(acc, field.key, current);
  }, {});
}

function stringifyValue(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  return typeof value === 'string' ? value : String(value);
}
